<template>
  <div class="box">
    <!-- <div class="top">
      <span>学生姓名：{{ userform.realName }}</span>
      <span>服务电话：{{ userform.contactPhone }}</span>
      <span>性别：{{ userform.sex == 0 ? "男" : "女" }}</span>
      <span v-if="userform.disciplineType == 0">科别：不分文理</span>
      <span v-if="userform.disciplineType == 1">科别：理科</span>
      <span v-if="userform.disciplineType == 2">科别：文科</span>
      <span v-if="userform.disciplineType == 0 || userform.disciplineType == 3 || userform.disciplineType == 4">科目：{{userform.discipline}}</span>
      <span v-if="userform.disciplineType == 4">科别：历史类</span>
      <span>所在中学：{{ userform.schoolName }}</span>
      <span>毕业年份：{{ userform.graduateYear }}</span>
      <span>高考成绩：{{ userform.score }}</span>
      <span>等位分：{{ userform.examscore }}</span>
      <span
        >位次：{{
          userform.scores
            ? userform.scores.accumulate
              ? userform.scores.accumulate
              : 0
            : 0
        }}</span
      >
      <span>修改日期：{{ userform.updateTime }}</span>
    </div> -->
    <el-tabs type="border-card">
      <el-tab-pane label="兴趣">
        <interest
          v-if="data.isInterest == 1"
          :interestResults="interestResults"
          :interestJson="interestJson"
        />
        <div v-else class="nulldiv">暂无测评结果</div>
      </el-tab-pane>
      <el-tab-pane label="性格">
        <character
          v-if="data.isCharacter == 1"
          :characterResults="characterResults"
          :characterJson="characterJson"
        />
        <div v-else class="nulldiv">暂无测评结果</div>
      </el-tab-pane>
      <el-tab-pane label="能力">
        <ability v-if="data.isAbility == 1" :abilityResults="abilityResults" :abilityJson="abilityJson"/>
        <div v-else class="nulldiv">暂无测评结果</div>
      </el-tab-pane>
      <el-tab-pane label="专业推荐">
        <professionalRecommendation
          v-if="data.isInterest == 1"
          :interestRecommend="interestRecommend"
        />
        <div v-else class="nulldiv">暂无测评结果</div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import interest from "./interest";
import character from "./character";
import professionalRecommendation from "./professionalRecommendation";
import ability from "./ability";
import { getAnswerResultByUserId } from "@/api/serviceManagement.js";
export default {
  components: {
    interest,
    character,
    professionalRecommendation,
    ability,
  },
  props: {
    userform: {
      Type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      user: {},
      characterResults: {},
      abilityResults: {},
      interestRecommend: {},
      interestResults: {},
      data: {},
    };
  },
  mounted() {
    // this.getAnswerResultByUserId();
  },
  watch: {
    userform: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.user = newValue;
        this.getAnswerResultByUserId();
      },
      deep: true,
    },
  },
  methods: {
    getAnswerResultByUserId() {
      if(this.user.userId){
        getAnswerResultByUserId({ userId: this.user.userId }).then((res) => {
        this.data = res.data || {};
        this.characterResults = this.data.characterResults || {};
        this.abilityResults = this.data.abilityResults || {};
        this.interestRecommend = this.data.interestRecommend || {};
        this.interestJson = JSON.parse(this.data.interestJson) || [];
        console.log(this.interestJson, "this.interestJson");
        this.characterJson = JSON.parse(this.data.characterJson) || [];
        this.abilityJson = JSON.parse(this.data.abilityJson) || [];
        this.interestResults = this.data.interestResults || {};
      });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .top {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
    margin-bottom: 10px;
    span {
      margin-right: 20px;
    }
  }
  .nulldiv {
    height: 800px;
    line-height: 800px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
  }
}
</style>